import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import classNames from 'classnames';

function RadialChart({ strokeWidth, dimension, data }) {
  const [strokeLengthAssigned, setStrokeLengthAssigned] = useState(false);
  let totalProgress = 0;

  useEffect(() => {
    setTimeout(() => {
      setStrokeLengthAssigned(true);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const radiusBaseOnStrokeWidth = (radius) => radius - strokeWidth / 2;

  const calculateStrokeDasharray = (item) => {
    const radius = radiusBaseOnStrokeWidth(item.radius);
    const circumference = 2 * 3.14 * radius;
    const strokeLength = strokeLengthAssigned
      ? (circumference * item.progress) / 100
      : 0;
    return `${strokeLength}, ${circumference}`;
  };

  const calculateStrokeDashoffset = (item, currentTotalProgress) => {
    const radius = radiusBaseOnStrokeWidth(item.radius);
    const circumference = 2 * 3.14 * radius;
    const strokeOffsetLength = (circumference * currentTotalProgress) / 100;
    return `-${strokeOffsetLength}`;
  };

  return (
    <div className="radial-chart">
      <svg viewBox="0 0 180 180" width={dimension} height={dimension}>
        {data.length > 0 &&
          data.map((item, index) => {
            const dom = (
              // eslint-disable-next-line react/no-array-index-key
              <Fragment key={index}>
                <circle
                  className={classNames('radial-chart-total', {
                    'zero-percent': item.progress === 0,
                  })}
                  stroke={item.progress === 0 ? item.color : '#F5F5F5'}
                  strokeWidth={strokeWidth}
                  fill="none"
                  cx="90"
                  cy="90"
                  r={radiusBaseOnStrokeWidth(item.radius)}
                />
                <circle
                  className="radial-chart-progress"
                  stroke={item.color}
                  strokeWidth={strokeWidth}
                  strokeDasharray={calculateStrokeDasharray(item)}
                  strokeDashoffset={calculateStrokeDashoffset(
                    item,
                    totalProgress,
                  )}
                  fill="none"
                  cx="90"
                  cy="90"
                  r={radiusBaseOnStrokeWidth(item.radius)}
                />
              </Fragment>
            );

            totalProgress += item.progress;
            return dom;
          })}
      </svg>
    </div>
  );
}

RadialChart.defaultProps = {
  strokeWidth: 12,
  dimension: 180,
};

RadialChart.propTypes = {
  strokeWidth: PropTypes.number,
  dimension: PropTypes.number,
  data: PropTypes.arrayOf(
    PropTypes.exact({
      radius: PropTypes.number,
      color: PropTypes.string,
      progress: PropTypes.number,
    }),
  ).isRequired,
};

export default RadialChart;
